import React from 'react'

import { downloadInvoice } from '../../api/routes'
import { Invoice } from 'models'

interface DownloadInvoiceProps {
    invoice: Invoice
}

export const DownloadInvoice = (props: DownloadInvoiceProps) => {
    const { invoice } = props

    return (
        <>
        <a
            href={downloadInvoice
                .replace('{invoiceId}', invoice.id.toString())
                .replace('{assumptive}', '0')
            }
            className="pdf-download"
            download
        >
            <sup>PDF</sup>
        </a>
        {invoice.sentAssumptive && (
            <>
            &nbsp;
            <a
                href={downloadInvoice
                    .replace('{invoiceId}', invoice.id.toString())
                    .replace('{assumptive}', '1')
                }
                className="pdf-download"
                download
            >
                <sup>Assumptive</sup>
            </a>
            </>
        )}
        </>
    )
}
